import {FireAuth, FireIncrement, FireTimestamp} from "../../../api/FirebaseService";

export const CURRENT_USER = () => FireAuth.currentUser.uid;
export const SERVER_TIMESTAMP = () => FireTimestamp();
export const INCREMENT = (n=1) => () =>FireIncrement(n) ;